module.exports = __webpack_public_path__ + "static/media/calendar.626fa65b.svg";